<div class="md-content rd-3">

  <div class="md-header text-center">
      <h3>{{'CANCEL_XP.title' | translate}}</h3>
  </div>

  <div class="md-body pb-4">
    <div class="bg-danger color-danger p-2 mb-3 d-flex align-items-center rd-3">
      <i class="material-icons mr-2">warning</i>
      <p class="mb-0 text-small">{{'CANCEL_XP.warning' | translate}}</p>
    </div>
    <ul class="list-style-none p-0 m-0">
      <li class="d-flex align-items-center p-2 m-0">
        <i class="material-icons color-danger mr-2">cancel</i>
        <p class="mb-0 text-small text-secondary">{{'CANCEL_XP.warning_account' | translate}}</p>
      </li>
      <li class="d-flex align-items-center p-2 m-0">
        <i class="material-icons color-danger mr-2">cancel</i>
        <p class="mb-0 text-small text-secondary">{{'CANCEL_XP.warning_clients' | translate}}</p>
      </li>
    </ul>
    <p class="p-3 text-secondary text-center">
      {{'CANCEL_XP.keep_access' | translate}}
    </p>

    <div class="md-actions">
      <div class="row">
        <div class="col text-center">
          <button class="btn btn-md btn-secondary mr-3" (click)="close()">{{'CANCEL_XP.back' | translate}}</button>
          <button class="btn btn-md btn-danger" (click)="cancelSubscription()">{{'CANCEL_XP.continue' | translate}}</button>
        </div>
      </div>
    </div>
  </div>


</div>